import request from '../utils/request'

// 获取注册或登陆的验证码
export function getRegisterOrLoginCode ({phone, phoneArea}) {
  return request({
    url: '/api/sms/registerOrLoginCode',
    method: 'GET',
    params: {
      phone, phoneArea
    }
  })
}
// 手机号注册+登陆
export function registerOrLogin (payload) {
  return request({
    url: '/api/user/registerOrLogin',
    method: 'POST',
    data: payload
  })
}

// APP用户详情
export function getInfo () {
  return request({
    url: '/api/user/myInfo/',
    method: 'GET'
  })
}

// 补充或修改APP用户信息
export function updateAppUserInfo (payload) {
  return request({
    url: '/api/user/updateAppUserInfo',
    method: 'POST',
    data: payload
  })
}

// 修改手机号
export function updatePhone (payload) {
  return request(
    {
      url: '/api/user/updatePhone',
      method: 'POST',
      data: payload
    }
  )
}
// 获取修改手机号的验证码
export function getUpdatePhoneCode () {
  return request(
    {
      url: '/api/sms/updatePhoneCode',
      method: 'GET'
    }
  )
}

// 根据微信重定向code查询用户是否绑定
export function checkCode (code) {
  return request({
    url: '/api/wechatUser/check/',
    params: {code},
    method: 'GET'
  })
}

// 我的捐款记录分页列表
export function getDonationRecord (payload) {
  return request({
    url: '/api/donationRecord/getMyPageList',
    method: 'POST',
    data: payload
  })
}

// 我要捐款
export function donation (payload) {
  return request({
    url: '/api/donationRecord/add',
    method: 'POST',
    data: payload
  })
}

// 会员价格表所有列表
export function getVipList () {
  return request({
    url: '/api/vipPrice/getAllList',
    method: 'POST'
  })
}
// 开通Vip
export function openVip (payload) {
  return request({
    url: '/api/vipRecord/open',
    method: 'POST',
    data: payload
  })
}
// 修改手机号,向新手机号发验证码
export function getNewPhoneCode (payload) {
  return request({
    url: '/api/sms/updatePhoneCodeToNew',
    method: 'GET',
    params: payload
  })
}
// 校验旧手机验证码-修改手机号
export function checkPhoneCodeOld (code) {
  return request({
    url: '/api/sms/checkPhoneCodeOld',
    method: 'GET',
    params: {code}
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js